import { apiHelper } from "./core"

const resourceManagemntServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

const getAvailableBeds = (body: any): Promise<any> => {
  return apiHelper
    .post(
      `${resourceManagemntServiceBaseUrl}/bed-management/availableBeds`,
      body
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const fetchRooms = (centerId: any): Promise<any> => {
  let url = centerId ? `room?centerId=${centerId}` : `room`
  return apiHelper
    .get(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const fetchBedAppointments = (
  centerId: any,
  bookingDate: any
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceManagemntServiceBaseUrl}/bed-booking/bookedBeds?centerId=${centerId}&bookingDate=${bookingDate}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const fetchAvailableBedSlots = (
  roomId: any,
  bookingDate: any,
  bedId: any
): Promise<any> => {
  return apiHelper
    .get(
      `${resourceManagemntServiceBaseUrl}/bed-booking/slots?roomId=${roomId}&bookingDate=${bookingDate}&bedId=${bedId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const bookBed = (body: any): Promise<any> => {
  return apiHelper
    .post(`${resourceManagemntServiceBaseUrl}/bed-booking`, body)
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const bookbedbyId = (id: any, body: any): Promise<any> => {
  return apiHelper
  .put(`${resourceManagemntServiceBaseUrl}/bed-booking/${id}`, body)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
export {
  getAvailableBeds,
  fetchRooms,
  fetchBedAppointments,
  fetchAvailableBedSlots,
  bookBed,
  bookbedbyId,
}
